<template>
	<el-dialog
		:show-close="closeAble"
		:title="title"
		:top="top"
		:visible.sync="isShowDialog"
		:width="width"
		append-to-body
		center>
		<div style="padding-bottom: 10px">
			<slot name="form_top"></slot>
		</div>
		<div v-if="!isForm">
			<avue-crud ref="crud_content" :cell-style="onCellStyle" :data="formDataList" :option="optionData"></avue-crud>
		</div>
		<div v-else>
			<avue-form ref="crud_content" v-model="formData" :option="optionData">
				<template slot="menuForm" slot-scope="scope">
					<el-button
						v-if="btnLeftText"
						:loading="btnLoading"
						style="margin: 0 15px"
						@click.prevent.native="onClickLeft">
						{{ btnLeftText }}
					</el-button>
					<el-button
						v-if="btnRightText"
						:loading="btnLoading"
						style="margin: 0 15px"
						type="primary"
						@click.prevent.native="onClickRight">
						{{ btnRightText }}
					</el-button>
				</template>
			</avue-form>
		</div>
		<div style="padding-top: 10px">
			<slot name="form_bottom"></slot>
		</div>
		<div v-if="!isForm" slot="footer">
			<el-button v-if="btnLeftText" :loading="btnLoading" style="margin: 0 15px" @click.prevent.native="onClickLeft">
				{{ btnLeftText }}
			</el-button>
			<el-button
				v-if="btnRightText"
				:loading="btnLoading"
				style="margin: 0 15px"
				type="primary"
				@click.prevent.native="onClickRight">
				{{ btnRightText }}
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {ChannelChangeOptionDialog, payerInfoOptionDialog} from '../../option/dialogOption'

export default {
	name: 'baseFormDialog',
	mixins: [],
	components: {},
	props: {
		title: {
			type: String,
			default: '提示',
		},
		isForm: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: '30%',
		},
		btnLeftText: String,
		btnRightText: String,
		formDataListTemp: {
			type: Array,
		},
		formOptionNumTemp: {
			type: String,
			default: '0',
		},
		top: {
			type: String,
			default: '25vh',
		},
		closeAble: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isShowDialog: false,
			//带有表格的dialog
			formOptionNum: this.formOptionNumTemp,
			optionData: {},
			formDataList: this.formDataListTemp,
			btnLoading: false,
			formData: {},
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		title(valNew, valOld) {
			if (valNew && valNew !== valOld) {
				this.title = valNew
			}
		},
		formOptionNumTemp(valNew, valOld) {
			//根据传递的number 获取option
			if (valNew !== valOld) {
				this.formOptionNum = valNew
				this.getOptions()
			}
		},
		formDataListTemp: {
			handler(valNew) {
				this.formDataList = valNew
				if (this.formOptionNum === '2' || this.formOptionNum === '3') {
					let index = this.formDataList.findIndex((itemData) => {
						return !this.validatenull(itemData.endorseNo)
					})
					//判断是否有批单号
					this.optionData.column[1].hide = index === -1
				}
			},
			deep: true,
		},
	},
	methods: {
		onClickLeft() {
			this.isShowDialog = false
			this.$emit('onClickLeft')
		},
		onClickRight() {
			if (this.formOptionNum === '0' || this.formOptionNum === '1') {
				this.isShowDialog = false
			}
			if (this.isForm) {
				//表格
				new Promise((resolve, reject) => {
					this.$refs.crud_content.validate((valid, done) => {
						if (valid) {
							resolve()
						}
						done()
					})
				}).then(() => {
					this.$emit('onClickRight', this.formData)
				})
			} else {
				this.$emit('onClickRight', this.formDataList[0])
			}
		},
		getOptions() {
			switch (this.formOptionNum) {
				// case '0':
				//   this.optionData = this.deepClone(optionRepeatHint)
				//   break
				// case '1':
				//   this.optionData = this.deepClone(optionRepeatHint)
				//   this.optionData.column[2].hide = true
				//   break
				// case '2':
				//   //结算申请 再次确认
				//   this.optionData = this.deepClone(fontApplyCommitOptionDialog)
				//   break
				// case '2.5':
				//   //结算申请 再次确认
				//   this.optionData = this.deepClone(fontApplyAwardCommitOptionDialog)
				//   break
				// case '3':
				//   //基础结算 退保修改结算费用
				//   this.optionData = this.deepClone(fontApplyBasicOptionDialog)
				//   break
				// case '3.5':
				//   //奖励结算 退保修改结算费用
				//   this.optionData = this.deepClone(fontApplyAwardOptionDialog)
				//   break
				// case '4':
				//   //处理结算申请 再次确认（通过，驳回等）
				//   this.optionData = this.deepClone(optionApplyHint)
				//   break
				// case '5':
				//   //费用核算修改
				//   this.optionData = this.deepClone(optionChangeFeeHint)
				//   break
				case '6':
					//付款人信息
					this.optionData = this.deepClone(payerInfoOptionDialog)
					break
				case '10':
					//付款人信息
					this.optionData = this.deepClone(ChannelChangeOptionDialog)
					break
			}
		},
		onCellStyle({row, column}) {
			if (this.formOptionNum === '2' || this.formOptionNum === '3') {
				if (row.settleMoney <= 0) {
					return {
						color: 'red',
					}
				}
			}
		},
		//异常保单修改的时候，需要传入金额提示
		show(feeCalc = 0) {
			this.isShowDialog = true
			if (this.isForm && this.formOptionNum !== '6') {
				//表单
				this.$nextTick(() => {
					if (this.$refs.crud_content) {
						this.$refs.crud_content.resetForm()
						if (this.formOptionNum === '5') {
							this.formData.isCalc = true
						}
						if (feeCalc !== 0) {
							this.optionData.column[0].placeholder = feeCalc
						}
					}
				})
			}
		},
		hide() {
			this.isShowDialog = false
		},
		isShow() {
			return this.isShowDialog
		},
		isShowLoading(isLoading = false) {
			this.btnLoading = isLoading
		},
	},
	created() {},
	mounted() {
		//先获取option
		this.getOptions()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
	padding: 10px 30px 10px !important;
}
</style>
